import React from 'react';
import './NoOfRecalledTransactionsCard.scss';
import { withResizeDetector } from 'react-resize-detector';
import { useSelector } from 'react-redux';
import RecalledRecordsChart from '../dashboard/RecalledRecordsChart';


const NoOfRecalledTransactionsCard = ({ width }) => {
  const spotCheckOverviewData = useSelector((state) => state.overview.spotCheckRecords);


  return (
    <div className="overview-recalled-records-card">
      <div className="overview-recalled-records-card-title">No of recalled transactions(photo taking/barcode)</div>
      <RecalledRecordsChart
        data={spotCheckOverviewData?.chartData}
        width={width - 75}
        height={250}
      />
    </div>
  );
};

export default withResizeDetector(NoOfRecalledTransactionsCard);
